import {
  collection,
  doc,
  getDocs,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

// ─── COLLECTIONS ──────────────────────────────────────────────────────────────
const tripsCol = collection(db, 'trips');
const postsCol = collection(db, 'posts');
const eventsCol = collection(db, 'events');
const configDoc = doc(db, 'siteConfig', 'main');
const corporateDoc = doc(db, 'corporate', 'main');

// ─── TRIPS ────────────────────────────────────────────────────────────────────
export async function getAllTrips() {
  const snap = await getDocs(tripsCol);
  return snap.docs.map(d => d.data());
}

export async function firestoreAddTrip(trip) {
  await setDoc(doc(db, 'trips', String(trip.id)), trip);
}

export async function firestoreUpdateTrip(trip) {
  await setDoc(doc(db, 'trips', String(trip.id)), trip);
}

export async function firestoreDeleteTrip(id) {
  await deleteDoc(doc(db, 'trips', String(id)));
}

// ─── POSTS ────────────────────────────────────────────────────────────────────
export async function getAllPosts() {
  const snap = await getDocs(postsCol);
  return snap.docs.map(d => d.data());
}

export async function firestoreAddPost(post) {
  await setDoc(doc(db, 'posts', String(post.id)), post);
}

export async function firestoreUpdatePost(post) {
  await setDoc(doc(db, 'posts', String(post.id)), post);
}

export async function firestoreDeletePost(id) {
  await deleteDoc(doc(db, 'posts', String(id)));
}

// ─── EVENTS ───────────────────────────────────────────────────────────────────
export async function getAllEvents() {
  const snap = await getDocs(eventsCol);
  return snap.docs.map(d => d.data());
}

export async function firestoreAddEvent(event) {
  await setDoc(doc(db, 'events', String(event.id)), event);
}

export async function firestoreUpdateEvent(event) {
  await setDoc(doc(db, 'events', String(event.id)), event);
}

export async function firestoreDeleteEvent(id) {
  await deleteDoc(doc(db, 'events', String(id)));
}

// ─── SITE CONFIG ──────────────────────────────────────────────────────────────
export async function getSiteConfig() {
  const snap = await getDoc(configDoc);
  return snap.exists() ? snap.data() : {};
}

export async function updateSiteConfigField(field, value) {
  await updateDoc(configDoc, { [field]: value });
}

// ─── CORPORATE ────────────────────────────────────────────────────────────────
export async function getCorporate() {
  const snap = await getDoc(corporateDoc);
  return snap.exists() ? snap.data() : {};
}

export async function firestoreUpdateCorporate(corporate) {
  await setDoc(corporateDoc, corporate);
}

// ─── SEEDING ──────────────────────────────────────────────────────────────────
export async function seedFirestore(defaultData) {
  for (const trip of defaultData.trips || []) {
    await setDoc(doc(db, 'trips', String(trip.id)), trip);
  }
  for (const post of defaultData.posts || []) {
    await setDoc(doc(db, 'posts', String(post.id)), post);
  }
  for (const event of defaultData.events || []) {
    await setDoc(doc(db, 'events', String(event.id)), event);
  }
  await setDoc(corporateDoc, defaultData.corporate || {});
  await setDoc(configDoc, {
    categories: defaultData.categories || [],
    about: defaultData.about || {},
    hero: defaultData.hero || {},
    contact: defaultData.contact || {},
    privacyPolicy: defaultData.privacyPolicy || [],
  });
}
